import "./TheLogbook.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import ResearchRecords from "./sections/ResearchRecords";
import InquiryDesk from "./sections/InquiryDesk";
import ObservatoryFooter from "@/reusable_sections/Footer";
export default function TheLogbookPage() {
  return <div>
      <NavigationPortal />
      <ResearchRecords />
      <InquiryDesk />
      <ObservatoryFooter />
    </div>;
}